import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children, user, profile, requireTeacher = false }) => {
  if (!user) return <Navigate to="/login" />;
  if (requireTeacher && (!profile || profile.isTeacher !== true)) {
    alert('Access denied. Teachers only.');
    return <Navigate to="/" />;
  }
  return children;
};
